var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownarrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Down_Arrow_3_",
    d: "M7.50003 9.75C7.32566 9.75 7.15111 9.67262 7.01799 9.51804L0.199815 1.60142C-0.066605 1.29207 -0.066605 0.791151 0.199815 0.482007C0.466235 0.172862 0.897655 0.172664 1.1639 0.482007L7.50003 7.83893L13.8362 0.482007C14.1026 0.172664 14.534 0.172664 14.8002 0.482007C15.0665 0.791349 15.0667 1.29227 14.8002 1.60142L7.98208 9.51804C7.84895 9.67262 7.67441 9.75 7.50003 9.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrowIcon);
export default __webpack_public_path__ + "static/media/downarrow_icon.9565bc9e5e585e57e4f511c78a5af00b.svg";
export { ForwardRef as ReactComponent };